module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', [(!_vm.profile) ? _c('div', [_vm._v("\n        No profile found "), _c('v-btn', {
    on: {
      "click": _vm.makeProfile
    }
  }, [_vm._v("Make")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pa-10 white ma-7 elevation-3",
    staticStyle: {
      "position": "relative",
      "xbackground-color": "rgba(0,0,0,0.0)"
    }
  }, [_c('div', {
    staticClass: "heading mb-3"
  }, [_vm._v("Your Personal Profile")]), _vm._v(" "), _c('FormControl', {
    attrs: {
      "schema": _vm.profileSchema
    },
    model: {
      value: (_vm.profile),
      callback: function($$v) {
        _vm.profile = $$v
      },
      expression: "profile"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fee590b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dc/Preferences.vue
// module id = 2672
// module chunks = 1